import { useTranslation } from "react-i18next";

export const ActivityStatusBadge = ({
  isNew,
  isMention = false,
}: {
  isNew: boolean;
  isMention?: boolean;
}) => {
  const { t } = useTranslation();
  if (!isNew) return null;

  return (
    <span
      className={`size-2 shrink-0 rounded-full ${isMention ? "bg-red-500" : "bg-sky-500"}`}
      role="img"
      aria-label={t(isMention ? "common.mention" : "common.unread", {
        defaultValue: isMention ? "Mention" : "Unread",
      })}
      title={t(isMention ? "common.mention" : "common.unread", {
        defaultValue: isMention ? "Mention" : "Unread",
      })}
    />
  );
};
